(function () {
  'use strict';
  var section = document.getElementById('readyPacks');
  if (!section) return;

  var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-ready-tab]'));
  var cards = Array.prototype.slice.call(section.querySelectorAll('[data-ready-pack]'));

  function showCount(count) {
    tabs.forEach(function (tab) {
      var active = Number(tab.dataset.readyTab) === count;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    });
    cards.forEach(function (card) {
      card.hidden = Number(card.dataset.count) !== count;
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () { showCount(Number(tab.dataset.readyTab)); });
  });

  cards.forEach(function (card) {
    var button = card.querySelector('[data-ready-add]');
    var status = card.querySelector('[data-ready-status]');
    if (!button) return;
    button.addEventListener('click', function () {
      var packId = 'WL-READY-' + Date.now().toString(36).toUpperCase();
      var items = String(card.dataset.items || '').split(',').filter(Boolean).map(function (entry) {
        var parts = entry.split(':');
        return {
          id: Number(parts[0]),
          quantity: Number(parts[1]),
          properties: {
            '_Wellubia pack': packId,
            '_Ready combination': card.dataset.name,
            '_Pack size': card.dataset.count
          }
        };
      });
      if (!items.length) return;
      button.disabled = true;
      button.textContent = 'Adding your combination';
      status.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.json();
        })
        .then(function (result) {
          if (window.wellubiaTrack) {
            window.wellubiaTrack('add_to_cart', {
              ecommerce: {
                currency: 'INR',
                value: Number(card.dataset.value || 0) / 100,
                items: (result.items || []).map(function (item) {
                  return {
                    item_id: String(item.product_id || item.id),
                    item_name: item.product_title,
                    price: Number(item.price || 0) / 100,
                    quantity: item.quantity
                  };
                })
              },
              pack_name: card.dataset.name,
              pack_size: Number(card.dataset.count)
            });
          }
          /* Shopify now applies the strongest eligible pack saving natively.
             Going straight to the cart also keeps the offer correct after a
             customer edits quantities or enters checkout from another page. */
          window.location.href = '/cart';
        })
        .catch(function () {
          status.textContent = 'This combination could not be added. Please try once more.';
          button.disabled = false;
          button.textContent = 'Add this combination';
        });
    });
  });

  showCount(2);
})();
